export const ApiUrls = {
	NewApi: import.meta.env.VITE_API_URL,
}
